import React, { useState } from "react";
import { Download, X, Share } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useInstall } from "@/context/InstallContext";

export const InstallAppBanner = () => {
  const ctx = useInstall();
  const [showHelp, setShowHelp] = useState(false);

  if (!ctx || !ctx.canShow || ctx.dismissed) return null;

  const install = async () => {
    const outcome = await ctx.install();
    if (outcome === "unavailable") setShowHelp((v) => !v);
  };

  return (
    <div
      className="fixed inset-x-0 bottom-0 z-[60] border-t border-white/10 bg-[#0D5C3A] shadow-[0_-8px_24px_rgba(0,0,0,0.18)]"
      data-testid="install-app-banner"
    >
      <div className="mx-auto flex max-w-6xl items-center gap-3 px-4 py-3">
        <div className="flex min-w-0 flex-1 items-center gap-3">
          <span className="hidden h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-white/15 text-white sm:flex">
            <Download className="h-5 w-5" />
          </span>
          <div className="min-w-0 text-left">
            <p className="truncate text-sm font-semibold text-white" data-testid="install-app-title">
              Download the RESTRO-VENDS shortcut
            </p>
            {showHelp ? (
              <p className="mt-0.5 flex items-center gap-1 text-xs text-white/85" data-testid="install-app-help">
                {ctx.isIOS && <Share className="h-3.5 w-3.5" />} {ctx.helpText}
              </p>
            ) : (
              <p className="mt-0.5 hidden text-xs text-white/70 sm:block">
                Add it to your home screen for one-tap access.
              </p>
            )}
          </div>
        </div>

        <Button
          onClick={install}
          size="sm"
          className="shrink-0 bg-white font-semibold text-[#0D5C3A] hover:bg-stone-100"
          data-testid="install-app-btn"
        >
          <Download className="mr-1 h-4 w-4" /> Download
        </Button>

        <button
          onClick={ctx.dismiss}
          aria-label="Close"
          className="shrink-0 rounded-md p-1 text-white/80 transition-colors hover:bg-white/10 hover:text-white"
          data-testid="install-app-close"
        >
          <X className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
};
